import { ReportsAPI, ReportURL } from "api/axios.config";

export const exportData = async ({
  reportName,
  requestBody,
  fileName = "export",
  format = "xlsx",
  onStart,
  onComplete,
  onError,
}) => {
  try {
    onStart?.();

    const url = `${ReportURL}/Reporting/export/${reportName}?format=${format}&downloadFilename=${fileName}.${format}`;

    const response = await ReportsAPI.post(url, requestBody, {
      headers: { "Content-Type": "application/json" },
      responseType: "blob",
    });

    if (response.status !== 200 || !(response.data instanceof Blob)) {
      throw new Error("Could not retrieve export document.");
    }

    const downloadUrl = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `${fileName}.${format}`;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      onComplete?.();
    }, 100);
  } catch (error) {
    onError?.(error);
    throw error;
  }
};
